


























  import {BASE_URL, ENDPOINTS, get, MainApi} from '@/api/mainApi';
  import Vue from 'vue';
  import {RequestSession} from "@/interfaces/requestSession";
  import {Donation} from "@/interfaces/donation/donation";

  export default Vue.extend({
    name: 'InvoiceComponent',
    components: {},
    props: {
      isImage: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        loading: false,
      };
    },
    computed: {
      requestSession(): RequestSession {
        return this.$store.state.requestSession
      },
      donation(): Donation {
        return this.$store.state.donation
      },
      currentStep() {
        return this.$store.state.currentStep
      },
    },
    watch: {},
    mounted() {
    },
    methods: {
      reset() {
        this.$emit('reset');
      },
      getInvoice(): string {
        return BASE_URL + "/" + MainApi + "/" + ENDPOINTS.INVOICE + "/" + ENDPOINTS.DOCUMENT + "?serialNumber=" + this.donation.serialnumber + "&asImage=" + this.isImage
      }
    },
  });
